/**
 * The label of each OFX account type code the server serves on a registered
 * account (`account_type`), so the Accounts section never shows the raw code
 * (walk-through round 1, finding 1). A code not in the table is shown as served.
 */
const ACCOUNT_TYPE_LABELS: Readonly<Record<string, string>> = {
  CHECKING: "Checking",
  SAVINGS: "Savings",
  CREDITCARD: "Credit card",
  MONEYMRKT: "Money market",
  CREDITLINE: "Line of credit",
};

/** The label for an account type code; any other code as served; "" for none. */
export function accountTypeLabel(code: string | null): string {
  if (!code) return "";
  return ACCOUNT_TYPE_LABELS[code] ?? code;
}

/**
 * The label of an account's purpose: "personal" is shown as "Personal books";
 * "business", the ordinary case, shows nothing.
 */
export function accountPurposeLabel(purpose: string | null): string {
  return purpose === "personal" ? "Personal books" : "";
}
